import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { formatDateForTableView } from '../../../functions/functions'

export const Location = ({ place, time }) => {
  const { t } = useTranslation('common')

  return (
    <div className={'ads-list-item-bottom-section'}>
      <div className='ads-list-item-bottom-section-place'>
        <span>{place}</span>

        <span>{formatDateForTableView(time, t)}</span>
      </div>
    </div>
  )
}

Location.propTypes = {
  place: PropTypes.string,
  time: PropTypes.string,
}
